import { useEffect, useState } from "react";
import ApiServices from "../../config/ApiServices";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { hideLoader, showLoader } from "../../redux/actions/LoaderActions";
import Loader from "../../utils/Loader";
import { showModal } from "../../redux/actions/ModalActions";
import Tooltip from '@mui/material/Tooltip';
import ModalManager from "../../Modals/ModalManager";
import { useParams } from "react-router-dom";
import { Link } from "react-router-dom";
import Pagination from "../../utils/Pagination";
import * as qs from "qs";
import { handleItemsPerPageChange, handlePageChange } from "../../utils/PaginationUtilities";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import IconButton from '@mui/material/IconButton';
import AttachmentIcon from '@mui/icons-material/Attachment';
export default function ViewTasks({ title }) {
    const dispatch = useDispatch();
    const loading = useSelector((state) => state.loader.loading);
    const isOpen = useSelector((state) => state.modal.isOpen);
    const [status, setStatus] = useState(true);
    const { batchId } = useParams();
    const [tasks, setTasks] = useState([]);
    const [marks, setMarks] = useState({});
    const [currentPage, setCurrentPage] = useState(0);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [totalData, setTotalData] = useState(0);
    
    const studentId = sessionStorage.getItem("userId");

    useEffect(() => {
    if (isOpen == false) {
        dispatch(showLoader());
        ApiServices.apiRequest("getTaskPagination", { 
            batchId: batchId, 
            limit: itemsPerPage, 
            pageno: currentPage + 1 
        })
            .then((res) => {
                if (res.data.success) {
                    const activeTasks = (res.data.data || []).filter(task => task.status === true);

                    setTotalData(activeTasks.length); 
                    setTasks(activeTasks);

                    console.log("tasks data:", activeTasks);

                    // Fetch marks for each active task
                    activeTasks.forEach((task) => {
                        ApiServices.apiRequest("getMarks", { studentId: studentId, testId: task._id })
                            .then((markRes) => {
                                if (markRes.data.success) {
                                    const marksArray = markRes.data.data;
                                    const studentMarks = marksArray?.find(mark => mark.studentId._id === studentId);

                                    setMarks((prevMarks) => ({
                                        ...prevMarks,
                                        [task._id]: studentMarks ? studentMarks.score : <span className="text-danger">No Marks</span>
                                    }));
                                } else {
                                    toast.error(markRes.data.message);
                                }
                            })
                            .catch((err) => {
                                toast.error(err?.message ? err?.message : "Something went wrong");
                            });
                    });
                } else {
                    console.log(res.data.message);
                }
            })
            .catch((err) => {
                toast.error(err?.message ? err?.message : "Something went wrong");
            })
            .finally(() => {
                dispatch(hideLoader());
            });
    }
}, [isOpen, status, currentPage, itemsPerPage, batchId]);



    return (
        <>
            <div className="container">
                <div className="page-inner">
                    {loading && !isOpen ? (
                        <Loader />
                    ) : (
                        <>
                            <div className="d-flex justify-content-between align-items-left align-items-md-center flex-column flex-md-row pt-2 pb-4">
                                <div>
                                    <h3 className="fw-bold mb-3">{title}</h3>
                                </div>
                                <div className="d-flex justify-content-end w-50">
                                    <Link to={`/student/graph/${batchId}/${studentId}`} className="btn btn-primary btn-round">
                                        Performance
                                    </Link>
                                </div>
                            </div>
                            {/* <hr/> */}
                            <div className="container">
                                <div className="row">
                                    {tasks?.length > 0 ? (
                                        tasks.map((task, index) => (
                                            <div className="col-sm-12 text-capitalize" key={index}>
                                                    <div className="d-flex justify-content-between">
                                                        <div>
                                                            <div className="fs-5">{task?.name}</div>
                                                            <span>MM: {task?.maximumMarks}</span>
                                                            <br />
                                                            
                                                            {/* Show trainer name directly from task.trainerId */}
                                                            {task?.trainerId?.name && (
                                                                <span className="text-info fw-bold">
                                                                    Posted By: {task.trainerId.name}
                                                                </span>
                                                            )}
                                                            <br />
                                                        </div>
                                                        <div className="d-flex">
                                                            <div>
                                                            <div className="text-end">Due: {task?.date}</div>
                                                                <div className=" ms-3 text-end">
                                                                    Marks: {marks[task._id] !== undefined ? marks[task._id] : 'Loading...'}
                                                                </div>
                                                            </div>
                                                            <div className="dropdown">
                                                                <IconButton type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                                                    <MoreVertIcon />
                                                                </IconButton>
                                                                <ul className="dropdown-menu">
                                                                    <li>
                                                                        <Link   
                                                                            to={"/student/viewTaskDetails/"+task?._id}
                                                                            className="dropdown-item"
                                                                        >
                                                                            View
                                                                        </Link>
                                                                    </li>
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </div>
                                                <hr className="my-1" />
                                            </div>
                                        ))
                                    ) : (
                                        <h1>No Task Present!!</h1>
                                    )}
                                </div>
                                <div className="d-flex justify-content-end">
                                    <Pagination
                                        count={totalData}
                                        page={currentPage}
                                        itemsPerPage={itemsPerPage}
                                        onPageChange={handlePageChange}
                                        onItemsPerPageChange={handleItemsPerPageChange}
                                    />
                                </div>
                            </div>
                        </>
                    )}
                </div>
            </div>
        </>
    );
}
